// Generated by CoffeeScript 1.12.7

/**
Get all the parameters in the query string

@method getQueryStringParameters
@return {Object}
 */
(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    return define('sp/utilities/get_query_string_parameters',[], factory);
  } else if (typeof module === 'object' && module.exports) {
    return module.exports = factory();
  } else {
    return root.getQueryStringParameters = factory();
  }
})(this, function() {
  var getQueryStringParameters;
  return getQueryStringParameters = function(url) {
    if (!url) {
      url = document.location.search;
    }
    if (url) {
      url = url.match(/(\?.*)/);
      if (!url || !url.length) {
        return {};
      }
      url = url[1];
    } else {
      return {};
    }
    return url.replace(/(^\?)/, '').split('&').map((function(n) {
      n = n.split('=');
      this[n[0]] = n[1];
      return this;
    }).bind({}))[0];
  };
});

